import { IMenuButton } from './menu-button.interface';

export class MenuButton implements IMenuButton {
    constructor(public label = 'Mettre à jour les données') {
    }
}
